import { Radio } from 'antd';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const GoodsWrapper = styled.div`
  width: 50%;
  .helperText {
    padding-left: 4px;
    color: rgba(0, 0, 0, 0.45);
  }
  .ant-radio-button-wrapper {
    width: 130px;
    text-align: center;
    line-height: 31px;
  }

  #goodsType .ant-radio-group,
  #vehicle .ant-radio-group {
    width: max-content;
  }
`;

export const AddressFormWrapper = styled.div`
  width: 50%;
  .ant-input-wrapper.ant-input-group {
    input {
      border-right: none !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .ant-input-group-addon {
      border: 1px solid #e4e6ef !important;
      border-left: none !important;
      border-top-right-radius: 0.42rem;
      border-bottom-right-radius: 0.42rem;

      .ant-input-search-button {
        border: none;
        box-shadow: none;
      }
    }
  }
`;

export const RadioGroupWrapper = styled(Radio.Group)`
  &.ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .ant-radio-button-wrapper,
    .ant-radio-button-wrapper:hover {
      display: flex;
      align-items: center;
      min-height: 60px;
      padding: 0px 14px;
      outline: 0.5px solid #e4e6ef; // 1px solid rgba(0, 0, 0, 0.4);
      border: 1px solid #e4e6ef; // 1px solid rgba(0, 0, 0, 0);
      border-radius: 8px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);

      .goods-name {
        font-size: 14px;
        color: #000000a6;
      }
      .goods-ex {
        font-size: 11px;
      }
      .size-description {
        white-space: break-spaces;
        text-align: end;
        line-height: 20px;
      }

      & span {
        width: 100%;
      }
      &:before {
        display: none;
      }
    }
    .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
      outline: 2px solid #46b476;
      .goods-name {
        color: #46b476;
      }
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
`;
